import { Component, OnInit } from '@angular/core';
import { ExternalSettingsService } from '../../services/external-settings/external-settings.service';

@Component({
    selector: 'app-top-menu-footer',
    templateUrl: './top-menu-footer.component.html',
    styleUrls: ['./top-menu-footer.component.less'],
    standalone: false
})
export class TopMenuFooterComponent implements OnInit {

  externalLoaded: boolean = false;
  copyrightMessage: string = '';

  colorButtonBackground!: Record<string, string>;
  constructor(private srvES : ExternalSettingsService) {}

  ngOnInit(): void {
    this.srvES.externalSettings$.subscribe((value) => {
      this.externalLoaded = true;

      if (value.systemVariables.copyrightMessage) {
        this.copyrightMessage = value.systemVariables.copyrightMessage;
      }      
    })
  }
}
